import { ConsultationCard, Consultation } from 'types';

export const isNearingDeadline = (
  consultation: Consultation | ConsultationCard | undefined
): boolean => {
  if (consultation === undefined) return false;
  if (consultation?.deadlineDate === undefined) return false;

  const daysTillDeadline =
    (new Date(consultation.deadlineDate).getTime() - new Date().getTime()) /
    (1000 * 60 * 60 * 24);

  return consultation.consultationType === 'RPC'
    ? daysTillDeadline <= 2 && daysTillDeadline > 0
    : daysTillDeadline <= 5 && daysTillDeadline > 0;
};
